import { useEffect } from "react";
import { useUser } from "./useUser";
import { api } from "../../api";
export const useAuth = () => {
    const [, setUser] = useUser();
    useEffect(() => {
        (process.env.NODE_ENV === "development" ? api.auth.getDevAuth() : api.auth.getAuthSso()).then(setUser);
    }, []); // eslint-disable-line
};
